import { observer } from 'mobx-react'
import React from 'react'
import ExternalLink from 'shared-components/ExternalLink'
import { Button } from 'ui-framework'
import CompensationVM from '../CompensationVM'

export function ApprovalCheck({ vm }: { vm: CompensationVM }) {
  return (
    <>
      <h4>Security check</h4>

      {!vm.approvalsChecked && (
        <>
          <p>We will check that the contracts that were compromised can not take away your BZRX.</p>

          <Button
            variant="green"
            className="btn--responsive"
            isLoading={vm.approvalsPending}
            disabled={!vm.canCheckApprovals}
            onClick={vm.checkDangerousApprovals}>
            Check my wallet
          </Button>
        </>
      )}

      {vm.approvalsChecked && vm.approvalsAreSafe && (
        <p className="txt-positive">
          <b>Good! Your BZRX are safe :)</b>
        </p>
      )}

      {vm.approvalsError && <p className="txt-negative">Error: {vm.approvalsError.message}</p>}
      {vm.approvalsChecked && !vm.approvalsAreSafe && !vm.approvalsError && (
        <div>
          <p className="txt-negative">
            <b>Your wallet is at risk!</b>
          </p>
          <p>You should revoke your BZRX spending approvals for these contracts immediately.</p>
          <ul className="txt-explanation">
            {vm.approvals
              .filter((approval) => approval.amount.gt(0))
              .map((approval) => (
                <li key={approval.spender}>{approval.spender}</li>
              ))}
          </ul>
          <ol className="list-spaced-1">
            <li>
              You can visit{' '}
              <ExternalLink
                className="link--discreet"
                href={`https://debank.com/profile/${vm.inputAddress}/approve?chain=matic`}>
                Debank
              </ExternalLink>{' '}
              to remove the spending approvals.
            </li>
            <li>
              Once the approvals are revoked, wait a few minutes and check your address again.
            </li>
          </ol>
        </div>
      )}
    </>
  )
}

export default observer(ApprovalCheck)
